import { assertNever } from "@msys/common";
import { StatusChip } from "@msys/ui";
import { useTranslate } from "@tolgee/react";
import React, { ComponentProps } from "react";
import { PimSupplierProductStatusValue } from "../../../clients/graphqlTypes.js";

interface Props {
  status: PimSupplierProductStatusValue;
}

export function SupplierProductStatusChip({ status }: Props) {
  const { t } = useTranslate(["SupplierProductStatus"]);

  const color = React.useMemo(() => statusColor(status), [status]);

  return (
    <StatusChip
      data-test-id="product-status-chip"
      label={t(status, { ns: "SupplierProductStatus" })}
      color={color}
    />
  );
}

function statusColor(
  status: PimSupplierProductStatusValue
): NonNullable<ComponentProps<typeof StatusChip>["color"]> {
  switch (status) {
    case "available":
      return "primary";
    case "endOfLife":
      return "warning";
    case "archived":
    case "discontinued":
    case "inactive":
    case "deprecated": {
      return "default";
    }
    case "draft":
    case "prelaunch": {
      return "secondary";
    }
    default:
      assertNever(status);
  }
}
